import React from 'react';
import * as Comp from '../editor/PuckComps';
import * as Opt from '../editor/Helpers';
import RadiusEditor from '../editor/fields/RadiusEditor';
import ColorSelector from '../editor/fields/ColorSelector';
import MediaSelector from '../editor/fields/MediaSelector';

class CardComponent extends React.Component {
    constructor() {
        super();
    }

    selectPaddingType(spacing) {
        if (this.props.morePadding != '0') {
            return spacing.filter((item) => item.type != 'p')
        } else {
            return spacing
        }
    }

    render() {
        let cardStyle = {}
        if (this.props.backgroundImage) {
            cardStyle.background = `url(${this.props.backgroundImage}) no-repeat`
            cardStyle.backgroundSize = 'cover'
            cardStyle.zIndex=1;
            if(this.props.backgroundImagePosition){
                cardStyle.backgroundPosition=this.props.backgroundImagePosition;
            }
        }
        const CardSlot = this.props.insertindexhere
        const isEditing = window.location.pathname.includes('editor');
        
        const cardContent =  Array.isArray(CardSlot) ? CardSlot : [];
        return <a  href={this.props.link && !isEditing ? this.props.link : undefined} className={`${isEditing && (["dt", "mob"].filter((i) => i === this.props.visibility).length) ? 'opacity-50' : this.props.visibility == "dt" ? 'hidden lg:block' : this.props.visibility == "mob" ? 'lg:hidden' : ''} overflow-hidden w-full min-w-0 h-full ${(Array.isArray(this.props.borderRadius)?this.props.borderRadius:[]).reduce((acum, itm) => acum+itm.radius+" ", "")} bg-${!this.props.backgroundImage ? this.props.backgroundColor : ''} ${this.props.boxShadow} ${Opt.CalculateSpacing(this.selectPaddingType(this.props.spacing))}`} style={ this.props.backgroundImage ? {...cardStyle, padding: `${this.props.morePadding}`} : { padding: `${this.props.morePadding}`, cursor: (this.props.link ? "cursor-pointer" : "cursor-default")} }>
            <div className={`w-full min-w-0 flex flex-wrap ${Opt.toTailwindClasses(this.props.horizontalAlign)} ${Opt.toTailwindClasses(this.props.verticalAlign)} ${Opt.toTailwindClasses(this.props.contentDirection)}`}>
                {window.location.pathname.includes('editor') && <CardSlot disallow={["Columns"]}/>}
                {cardContent.map((comp, index) => {
                    // Loop over all the components for that column and render them within
                    let Component = Comp[comp.type]
                    if (!Component) {
                        console.warn(`Nested component type "${comp.type}" not found in CardComponent.`);
                        return null;
                    }
                    return <Component key={index} {...comp.props} />
                })}
               
            </div>
        </a>
    }
}

CardComponent.defaultProps = {
    visibility: "",
    morePadding: "0",
    boxShadow: "shadow-none",
    horizontalAlign: "justify-start",
    verticalAlign: "items-stretch",
    contentDirection: "flex-col",
    insertindexhere: [],
    borderRadius: [],
    spacing:[],
    backgroundColor: 'neutral-stone-500',
    // cardHeight: "250px", // unused
    link: "",
}

CardComponent.fields = {
    id: {
        type: "custom",
        render: ({ name, onChange, value }) => (
            <p style={{fontSize:"12px"}}>{value}</p>
        )
    },
    // Old dropzone
    insertindexhere:{
        type: "slot",      
    },
    backgroundImagePosition: {
        type: "select",
        options: ["top", "bottom", "center"].reduce((acum, itm) => {
            ["left", "right", "center"].forEach((itm2) => {
            acum.push({label:itm+" "+itm2, value:itm+" "+itm2})
            })
                return acum;
        }, [{label:"top", value:"top"}, {label:"bottom", value:"bottom"}, {label:"center", value:"center"}, {label:"left", value:"left"}, {label:"right", value:"right"}])
    }, 
    visibility: {
        type: "select",
        options: Opt.visibilityOptions
    },
    morePadding: {
        type: "text",
    },
    boxShadow: {
        type: "select",
        options: Opt.boxShadow
    },
    borderRadius:{
        type: "array",
        arrayFields: {
            radius:{
                type: "custom",
                render: ({name, onChange, value}) => <RadiusEditor name={name} onChange={onChange} value={value} />
            }
        }
    },
    spacing:Opt.spacingOptions,
    horizontalAlign: {
        type: "select",
        options: Opt.contentJustify,

    },
    verticalAlign: {
        type: "select",
        options: Opt.contentAlignItems,

    },
    contentDirection: {
        type: "select",
        options: [{ label: "Row", value: "flex-row" }, { label: "Column", value: "flex-col" }, { label: "Row Reverse", value: "flex-row-reverse" }, { label: "Column Reverse", value: "flex-col-reverse" }]
    },
    backgroundColor: {
        type: "custom",
        render: (props) => <ColorSelector {...props} />
    },
    backgroundImage: {
        type: "custom",
        render: ({ name, onChange, value }) => <MediaSelector name={name} type={'img'} onChange={onChange} value={value} />,
    },
    // cardHeight: { type: "text" }, // unused in render
    link:{
        type: "text",
    }
}

export default CardComponent;